export namespace NMyOutfits {
    export const componentId = 'account-my-outfits';

    export interface IMyOutfitsContent {
        title?: string;
        subtitle?: string;
        outfitBuilderLink?: string;
        buildNewOutfitText?: string;
        startNowText?: string;
        noOutfitsTitle?: string;
        noOutfitsSubtitle?: string;
        shopThisLookText?: string;
    }

    export interface ISavedOutfit {
        id: number;
        dateCreated: string; // ISO date string
        dateUpdated: string; // ISO date string
        outfitData: string; // base64 encoded outfit configuration data
    }

    export interface ISavedOutfitsData {
        outfits: ISavedOutfit[];
    }

    export const MAX_SAVED_OUTFITS = 50;
}
